<template>
	<div>
		<el-row type="flex" justify="center" style="margin-top:120px;">
			<el-card class="box-card" style="width:40%;">
				<div slot="header" class="clearfix">
					<span style="text-align: left;">用户登录</span>
				</div>
				<div style="padding-right: 70px;">
					<el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="账户" prop="acc">
							<el-input v-model="ruleForm.acc" placeholder="手机号"></el-input>
						</el-form-item>
						<el-form-item label="密码" v-if="logtype==1" prop="pwd">
							<el-input v-model="ruleForm.pwd" type="password" :show-password="true" placeholder="密码">
							</el-input>
						</el-form-item>
						<el-form-item label="验证码" v-if="logtype==2" prop="yzm">
							<el-input placeholder="请输入验证码" v-model="ruleForm.yzm">
								<template  slot="append"><span style="cursor: pointer;" @click="getMsg">获取验证码</span></template>
							</el-input>
						</el-form-item>
						<el-form-item style="text-align: left;">
							<el-button-group>
								<el-button @click="setlogtype(1)">密码登录</el-button>
								<el-button @click="setlogtype(2)">短信登录</el-button>
							</el-button-group>
						</el-form-item>
						<el-form-item style="text-align: left;">
							<el-button type="primary" :disabled="canSubmit" @click="submitForm()">登录
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-card>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				canSubmit: false,
				logtype: 1,
				ruleForm: {
					action: 'CustLogin',
					acc: '',
					pwd: '',
				},
				msgForm: {
					action: 'SendSms',
					telno: '',
					TemplateID: '914725',
					templateParamSet: '976995,5'
				},
				code: ''
			}
		},
		created() {

		},
		methods: {
			getMsg() {
				let self = this
				if (self.ruleForm.acc.length != 11) {
					self.$message.error('请输入手机号码')
					return
				}
				let url = 'https://www.liligc.com/NWCenter/dlAppTest';
				for (var i = 0; i < 6; i++) {
					self.code += parseInt(Math.random() * 10)
				}
				setInterval(function() {
					self.code = ''
				}, 30000)
				self.msgForm = {
					action: 'SendSms',
					telno: self.ruleForm.acc,
					TemplateID: '914725',
					templateParamSet: self.code + ',5'
				}
				self.axios.get(url, {
					params: self.msgForm
				}).then((res) => {
					if (res.data.result) {
						self.$message.success(res.data.msg)
					} else {
						self.canExec = false
					}
				}).catch(function(err) {
					self.$message.error(err)
				}).finally(() => {
					self.canSubmit = false
				});
			},
			setlogtype(val) {
				let self = this
				self.logtype = val
			},
			submitForm() {

				let self = this
				if (self.logtype == 2) {
					if (self.code != self.ruleForm.yzm) {
						self.$message.success('验证码不正确')
						return;
					}
				}
				self.canSubmit = true
				let pcform = ''
				let url = 'https://www.liligc.com/NWCenter/dlAppTest';
				if (self.logtype == 1) {
					pcform = self.ruleForm
				} else {
					self.msgForm.telno = self.ruleForm.acc
					pcform = self.msgForm
				}
				self.axios.get(url, {
					params: pcform
				}).then((res) => {
					if (res.data.result) {
						self.$message.success(res.data.msg)
						self.$refs['ruleForm'].resetFields();
						let userInfo = res.data.joCust;
							this.$store.commit("$_login", userInfo);
						self.$router.push('/')
					} else {
						self.canExec = false
					}
				}).catch(function(err) {
					self.$message.error(err)
				}).finally(() => {
					self.canSubmit = false
				});
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
